import { formatMakeModelYear } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

const MAX_LENGTH = 25

// TODO: rewrite logic for formating
export const makeModelYear = ({ make, model, year, stockNumber }: SearchVehicle): string => {
    const mmy = formatMakeModelYear({ year, make, model }).toUpperCase()
    const mmyTooLong = mmy.length > MAX_LENGTH
    const mmyShort = `${mmy.substring(0, MAX_LENGTH)}…`
    const checkStockNumber = stockNumber ? `(${stockNumber})` : ''

    return `${mmyTooLong ? mmyShort : mmy} ${checkStockNumber}`
}
